import { SETTING_CODE_REF, TASK_NUMBER_AUTO_GEN } from 
         '@app/constants/Setting.constant';

class Setting 
{
    public static isTaskNumberAutoGen
    (
        value
    ) : boolean
    {
        let autoGen: boolean;
        
        if (value == TASK_NUMBER_AUTO_GEN.TASK_NUMBER_AUTO)
        {
            autoGen = true;
        }
        else
        {
            autoGen = false;    
        }
        
        return autoGen;    
    }
        
    public static getTaskNumberCode
    (
        settings
    ) : boolean
    {
        let i;
        let setting;
        let taskNumberSetting;
        
        // initialize variables
        setting = null;
        
        for (i=0;i<settings.length;i++)
        {
            setting = settings[i];
        
            if (setting.code == SETTING_CODE_REF.TASK_NUMBER_GEN_CODE) 
            {
                break;
            }
        }
        
        return setting;
    }
    
}

export { Setting };
